var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10252_2957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10252_2957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3551 1.2168C9.99053 1.2168 6.4302 4.78932 6.4302 9.15374C6.4302 11.8225 7.76432 14.1857 9.79694 15.6234C5.0581 17.5222 1.69633 22.1556 1.69633 27.5619C1.70359 27.8886 1.83847 28.1995 2.0721 28.428C2.30573 28.6565 2.61954 28.7845 2.94633 28.7845C3.27313 28.7845 3.58694 28.6565 3.82057 28.428C4.0542 28.1995 4.18908 27.8886 4.19634 27.5619C4.19634 21.8243 8.82006 17.2006 14.5577 17.2006C16.5605 17.2006 18.4196 17.7716 20.002 18.7509C20.1421 18.8381 20.298 18.8968 20.4609 18.9237C20.6237 18.9505 20.7902 18.9449 20.9509 18.9073C21.1116 18.8696 21.2632 18.8007 21.3972 18.7044C21.5312 18.6081 21.6449 18.4863 21.7317 18.3459C21.8186 18.2057 21.8769 18.0496 21.9033 17.8867C21.9298 17.7238 21.9239 17.5573 21.8859 17.3967C21.8479 17.2361 21.7786 17.0846 21.682 16.9509C21.5854 16.8171 21.4633 16.7037 21.3228 16.6171C20.6098 16.1759 19.8357 15.8304 19.0376 15.5332C21.0038 14.0879 22.2921 11.7685 22.2921 9.15374C22.2921 4.78932 18.7195 1.2168 14.3551 1.2168ZM14.3551 3.71914C17.3684 3.71914 19.7896 6.14038 19.7896 9.15374C19.7896 12.1672 17.3684 14.5786 14.3551 14.5786C11.3416 14.5786 8.93022 12.1672 8.93022 9.15374C8.93022 6.14038 11.3416 3.71914 14.3551 3.71914Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3277 23.4923C16.7859 22.9692 15.9227 22.9842 15.3996 23.5258C14.8892 24.0543 14.8892 24.892 15.3996 25.4205L19.4905 29.5114C20.0067 30.0277 20.8381 30.0458 21.3764 29.5523L29.5582 22.0523C30.1132 21.5432 30.1504 20.6805 29.6413 20.1255C29.1322 19.5705 28.2695 19.5332 27.7145 20.0423L20.4954 26.6601L17.3277 23.4923Z",
    fill: "#04385D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAgent);
export default __webpack_public_path__ + "static/media/Active Agent.bd7a1bf161772e2d6e3de181373942d6.svg";
export { ForwardRef as ReactComponent };